import { useCallback, useState, ChangeEvent, ChangeEventHandler } from "react";

export default function useFormValue(
  initialValue: string = ""
): [string, ChangeEventHandler<HTMLInputElement | HTMLSelectElement>] {
  const [value, setValue] = useState<string>(initialValue);

  const onChange = useCallback(
    (event: ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
      const newValue = event.target.value;
      setValue(newValue);
    },
    [setValue]
  );
  return [value, onChange];
}
